<div class="pt-spinner">
  @if (!isTwOrEdOther) {
    <ng-lottie
      [options]="options()"
      class="pt-spinner__animation-lottie"
    />
  }

  <div class="pt-spinner__circles">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
